import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject10() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  box-shadow: 0 9px 20px 0 rgba(0, 0, 0, 0.1);\n  height: 100%;\n  background-color: ", ";\n  overflow-y: auto;\n  position: absolute;\n  z-index: -100;\n  padding: ", "px;\n  left: ", "px;\n  top: ", "px;\n  width: ", "px;\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-top: auto;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: 0 9px 20px 0 rgba(0, 0, 0, 0.1);\n  background-color: white;\n  border-right: solid 1px rgba(0, 115, 119, 0.11);\n  display: flex;\n  flex-direction: column;\n  padding: ", "px ", "px;\n  height: 100%;\n  width: ", "px;\n  overflow: visible auto;\n  position: absolute;\n  z-index: 1;\n  transition: box-shadow 0.5s;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  border: solid 1px transparent;\n  border-radius: ", "px;\n  &:focus {\n    border: dotted 1px ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border: solid 1px transparent;\n  border-radius: ", "px;\n  &:focus {\n    border: dotted 1px ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin: ", "px 0;\n  ", ";\n  text-decoration: none;\n\n  &:focus,\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px 0;\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  font-size: 22.8px;\n  letter-spacing: 1px;\n  line-height: ", "px;\n  padding: ", "px 0;\n  text-align: left;\n  text-decoration: none;\n  ", ";\n  ", ";\n  &:focus,\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { animated } from "react-spring";
import { typography, size, colors } from "../../../../shared/constants";
import { commonTransition } from "../styles";
import { TertiaryLink } from "../../../TertiaryLink";
import { DesktopMenuCard } from "../DesktopMenuCard";
import { DesktopMenuPromoCard } from "../DesktopMenuPromoCard";
export var MenuButon = styled.button(_templateObject(), colors.green5, size.xl1, size.md, commonTransition, function (o) {
  return o.active ? "color: " + colors.teal6 : null;
}, colors.teal6);
export var ShopAllMenuButton = styled(TertiaryLink)(_templateObject2(), size.sm, colors.green5, colors.teal5);
export var ProductLink = styled.a(_templateObject3(), size.md, typography.buttonTextSmall, colors.teal6);
export var ProductCard = styled(DesktopMenuCard)(_templateObject4(), size.xs1, colors.teal3);
export var PromoCard = styled(DesktopMenuPromoCard)(_templateObject5(), size.xs1, colors.teal3);
var primaryDrawerWidth = 360;
export var DrawerPrimaryContent = styled(animated.nav)(_templateObject6(), size.xl3, size.xl3, 360);
export var ProductPromoWrapper = styled.div(_templateObject7());
export var DrawerSecondaryContent = styled(animated.div)(_templateObject8(), colors.white, size.xl3, 360, 0, 360 * 1.41, function (o) {
  return o.active ? "display: block" : null;
});
export var SubMenuSectionWrapper = styled.div(_templateObject9(), size.lg);
export var SubmenuContentWrapper = styled(animated.div)(_templateObject10());